import Router from 'vue-router';
import ProductPage from './views/ProductPage/index.vue';

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      name: 'ShortPath',
      path: '/:locale/:storeCode/p/:productId',
      component: ProductPage,
    },
    {
      name: 'FullPath',
      path: '/:locale/:storeCode/p/:productId?/pn/:partNumber',
      component: ProductPage,
    },
    {
      name: 'ViewerPath',
      path: '/:locale/:storeCode/p/:productId?/pn/:partNumber/imageviewer',
      component: ProductPage,
    },
  ],
});
